import React from 'react';
import {
  ProFormText,
  ProFormTextArea,
  ProFormSwitch,
  ProFormDigit,
} from '@ant-design/pro-form';
import ProForm from '../../../layout/ProForm';
import PropTypes from 'prop-types';

const ProjectTypeForm = ({ onFinish, initialValues, isEdit }) => {
  return (
    <ProForm
      onFinish={onFinish}
      initialValues={{ ...initialValues, active: !initialValues.disabled }}
    >
      <ProFormText
        width="xl"
        name="name"
        label="Name"
        rules={[
          { required: true, message: 'Please enter faculty name!' },
          { whitespace: true },
        ]}
      />
      <ProFormDigit
        width="xl"
        label="Display Sequence"
        name="seq"
        min={1}
        max={9999}
        fieldProps={{ precision: 0 }}
        rules={[{ required: true }]}
      />
      <ProFormTextArea width="xl" name="description" label="Description" />
      {isEdit && <ProFormSwitch name="active" label="Active" />}
    </ProForm>
  );
};

ProjectTypeForm.defaultProps = {
  initialValues: {},
  isEdit: false,
};

ProjectTypeForm.propTypes = {
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  isEdit: PropTypes.bool.isRequired,
};

export default ProjectTypeForm;
